import React from "react";
import { Modal } from "@shared/ui/Modal";
import { SuccessModalIcon } from "public/static/icons";
import styled from "styled-components";
import { Button } from "@shared/ui/Button";
import { Typography } from "@shared/ui/Typography";

interface IProps {
  show: boolean;
  title: string;
  description: string;
  buttonLabel: string;
  onClose: () => void;
}

export function SuccessModal({
  show,
  onClose,
  title,
  description,
  buttonLabel,
}: IProps) {
  return (
    <Modal show={show} onClose={onClose}>
      <StyledBody>
        <SuccessModalIcon />
        <StyledTitle tag="h4" fontSize="2.4rem" weight={700}>
          {title}
        </StyledTitle>
        <StyledSubtitle tag="p">{description}</StyledSubtitle>
        <StyledButton onClick={onClose}>{buttonLabel}</StyledButton>
      </StyledBody>
    </Modal>
  );
}

const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 38.6rem;

  @media screen and (max-width: ${(props) => props.theme.sizes.tablet}) {
    max-width: unset;
  }
`;

const StyledTitle = styled(Typography)`
  margin-top: 2.4rem;
  margin-bottom: 2rem;
  text-align: center;
`;

const StyledSubtitle = styled(Typography)`
  margin-bottom: 4.8rem;
  text-align: center;
`;

const StyledButton = styled(Button)`
  align-self: stretch;
`;
